import React from "react";
import { CheckCircle2, AlertCircle } from "lucide-react";

export const ReportVoice = ({ strategy }) => {
  const voice = strategy.brand_voice || {};
  return (
    <div className="space-y-6">
      {voice.tone && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4">Tone of Voice</h3>
          <div className="flex flex-wrap gap-2">
            {voice.tone.map((t) => (
              <span key={`tone-${t}`} className="px-4 py-2 bg-emerald-500/20 text-emerald-400 rounded-full text-sm font-medium">
                {t}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
        <h3 className="font-semibold text-white mb-2">Voice Characteristics</h3>
        <p className="text-slate-300">{voice.voice_characteristics || "N/A"}</p>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {voice.dos && (
          <div className="bg-emerald-900/20 border border-emerald-500/30 rounded-2xl p-6">
            <h3 className="font-semibold text-emerald-400 mb-4 flex items-center gap-2">
              <CheckCircle2 className="w-5 h-5" /> Do&apos;s
            </h3>
            <ul className="space-y-2">
              {voice.dos.map((item) => (
                <li key={`do-${item.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                  <span className="text-emerald-400">&#8226;</span> {item}
                </li>
              ))}
            </ul>
          </div>
        )}
        {voice.donts && (
          <div className="bg-red-900/20 border border-red-500/30 rounded-2xl p-6">
            <h3 className="font-semibold text-red-400 mb-4 flex items-center gap-2">
              <AlertCircle className="w-5 h-5" /> Don&apos;ts
            </h3>
            <ul className="space-y-2">
              {voice.donts.map((item) => (
                <li key={`dont-${item.slice(0, 30)}`} className="flex items-start gap-2 text-slate-300">
                  <span className="text-red-400">&#8226;</span> {item}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
